import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import InputIcon from "react-multi-date-picker/components/input_icon";
import DatePicker from "react-multi-date-picker";

export const PayoutFilter = ({
  toolTipError,
  t,
  setDate,
  downloadData,
  isPension,
}) => {
  return (
    <div className="agreements-list holiday_Wrapper">
      <>
        <h4 className="accident_ins font-weight-bold">
          {isPension ? t("Your pension amount") : t("Your holiday pay amount")}
        </h4>
        <p className="mb-0">
          <span>
            {isPension
              ? t("Here you can see your pension amount")
              : t("Here you can see your holiday pay amount")}
          </span>
        </p>
        <p>
          <span>
            {t(
              "To see the details, you have to select the dates from the calendar below and then click on the download button."
            )}
          </span>
        </p>
      </>

      <div className="row m-0 invoices-row">
        <div className="col-md-3 pl-0 col-sm-6 mb-2">
          <OverlayTrigger
            show={
              toolTipError.invalidFromdate || toolTipError.fromDateNotSelected
            }
            placement="top"
            overlay={
              <Popover id={`popover-positioned-top`} style={{ margin: 0 }}>
                <Popover.Header className="text-danger" as="h3">
                  {toolTipError.invalidFromdate &&
                    t("The start date should be greater than the end date.")}
                  {toolTipError.fromDateNotSelected &&
                    t("Please select the starting date from the calander.")}
                </Popover.Header>
              </Popover>
            }
          >
            <DatePicker
              render={<InputIcon placeholder={t("From")} />}
              onChange={(date) => {
                const dateString = new Date(date).toISOString().split("T")[0];
                setDate((prevState) => ({
                  ...prevState,
                  from: dateString,
                }));
              }}
            />
          </OverlayTrigger>
        </div>
        <div className="col-md-3 pl-0 col-sm-6 mb-2">
          <OverlayTrigger
            show={toolTipError.toDateNotSelected}
            placement="top"
            overlay={
              <Popover id={`popover-positioned-top`} style={{ margin: 0 }}>
                <Popover.Header className="text-danger" as="h3">
                  {toolTipError.toDateNotSelected &&
                    t("Please select the end date from the calander")}
                </Popover.Header>
              </Popover>
            }
          >
            <DatePicker
              render={<InputIcon placeholder={t("To")} />}
              className="ml-2"
              onChange={(date) => {
                const dateString = new Date(date).toISOString().split("T")[0];
                setDate((prevState) => ({
                  ...prevState,
                  to: dateString,
                }));
              }}
            />
          </OverlayTrigger>
        </div>
        <Button
          variant="outline-primary"
          className="mb-2"
          onClick={() => downloadData()}
        >
          {t("Search")}
        </Button>
      </div>
    </div>
  );
};
